import { CancelToken } from 'axios';
import { GET, POST } from '../../service/HttpMethod';
import { ActivityAcknowledgeReason, ActivityNotification, ActivityNotificationPage } from './types';

const unwrap = <T>(response: any): T => {
	const body = response && response.data !== undefined ? response.data : response;
	return (body && body.data !== undefined ? body.data : body) as T;
};

export const getActivityNotificationPage = async (
	cursor = 0,
	limit = 100,
	cancelToken?: CancelToken,
): Promise<ActivityNotificationPage> =>
	unwrap<ActivityNotificationPage>(
		await GET({
			url: 'users/me/activity-notifications',
			params: { cursor, limit, status: 'unread' },
			cancelToken,
		}),
	);

export const getAllActivityNotifications = async (
	cancelToken?: CancelToken,
): Promise<ActivityNotification[]> => {
	const notifications: ActivityNotification[] = [];
	let cursor = 0;
	for (let page = 0; page < 100; page += 1) {
		const result = await getActivityNotificationPage(cursor, 100, cancelToken);
		const rows = Array.isArray(result.notifications) ? result.notifications : [];
		notifications.push(...rows);
		if (!result.nextCursor || result.nextCursor === cursor) break;
		cursor = result.nextCursor;
	}
	return notifications;
};

export const acknowledgeActivityNotifications = async (
	recipientIds: number[],
	reason: ActivityAcknowledgeReason,
) =>
	unwrap<{ acknowledged: number; available?: boolean }>(
		await POST({
			url: 'users/me/activity-notifications/acknowledge',
			data: { recipientIds, reason },
		}),
	);
